// Computes viewport-coord position for a floating element relative to a reference.
// Pair with `position: fixed` on the floating element. Flips to the opposite side
// when the preferred placement lacks room; clamps horizontally to the viewport.

const VIEWPORT_MARGIN = 8;

export function positionPopover(
  reference,
  floating,
  { placement = "bottom", offset = 8 } = {},
) {
  const ref = reference.getBoundingClientRect();
  const fl = floating.getBoundingClientRect();
  const vw = window.innerWidth;
  const vh = window.innerHeight;

  const spaceBelow = vh - ref.bottom;
  const spaceAbove = ref.top;
  const needed = fl.height + offset;

  let side;
  if (placement === "auto") {
    side = spaceBelow >= spaceAbove ? "bottom" : "top";
  } else if (placement === "top") {
    side = spaceAbove < needed && spaceBelow >= needed ? "bottom" : "top";
  } else {
    side = spaceBelow < needed && spaceAbove >= needed ? "top" : "bottom";
  }

  const top =
    side === "bottom" ? ref.bottom + offset : ref.top - fl.height - offset;

  const idealLeft = ref.left + ref.width / 2 - fl.width / 2;
  const left = Math.max(
    VIEWPORT_MARGIN,
    Math.min(idealLeft, vw - fl.width - VIEWPORT_MARGIN),
  );

  return { top, left, placement: side };
}
